:host {
  display: block;
  position: relative;
}

.upcoming-invoice {
  display: grid;
  gap: var(--sc-spacing-large);


  > *  {
    display: grid;
    gap: var(--sc-spacing-medium);
  }
}

.new-plan {
  display: grid;
  gap: 0.25em;
  color: var(--sc-input-label-color);

  &__heading {
    font-weight: var(--sc-font-weight-bold);
  }
}
